import { useAuth } from '@/hooks/useAuth';
import { Navigate } from 'react-router';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: 'ADMIN' | 'USER';
  fallbackPath?: string;
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  requiredRole,
  fallbackPath = '/',
}) => {
  const { isAuthenticated, isLoading, role } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with your loading component
  }

  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Redirect if user doesn't have the required role
  if (role !== requiredRole) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
